module.exports = __webpack_public_path__ + "static/hateoas-ddd-761d2d51184063a262abfe36499b23c1.png";